<template>
  <div class="component-content sub-content">
    <div class="tab-radio-tool">
      <el-radio-group size="mini" v-model="listType">
        <el-radio-button label="0">采购申请</el-radio-button>
        <el-radio-button label="1">采购备案</el-radio-button>
      </el-radio-group>

      <label style="margin-left:15px;">搜索：</label>
      <el-input v-model="filterKey" style="width:400px;" size="mini" placeholder="你可以搜索采购编号/采购项目/审批发起人"></el-input>
    </div>


    <!-- <div class="tab-radio-tool">
      <el-radio-group size="mini" v-model="listType">
        <el-radio-button label="0">进行中</el-radio-button>
        <el-radio-button label="1">已审批通过</el-radio-button>
        <el-radio-button label="2">已取消/拒绝</el-radio-button>
        <el-radio-button label="1">已审批(已取消、已拒绝)</el-radio-button>
      </el-radio-group>
     -->

    <el-table :data="paginationData" border style="width: 100%" v-loading="loading">
      <el-table-column type="index" label="序号" width="50" align="center">
      </el-table-column>
      <el-table-column prop="number" label="采购申请编号" width="120">
      </el-table-column>
      <el-table-column prop="name" label="采购项目">
      </el-table-column>

      <el-table-column prop="department.name" label="申请部门">
      </el-table-column>

      <el-table-column label="审批发起人" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>

      <el-table-column label="审批状态" width="100px" align="center">
        <template slot-scope="scope">
          <approval-status :flow="scope.row.flow" :approvals="scope.row.flow.approvals" :status="scope.row.flow.status"></approval-status>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120px">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="projectDetail(scope.row)">详情</el-button>
          <!-- 填表人修改权限 -->
          <span v-if="scope.row.flow.creator.id==userData.id">
            <span v-if="scope.row.flow.status!='审批通过'">
              <el-tooltip class="item" effect="dark" content="修改采购申请" placement="bottom">
                <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit"
                  @click="getRouterLink(scope.row.flow.applyId)"></i>
              </el-tooltip>
            </span>
            <cancel-flow :successPlus="true" :flow="scope.row.flow" @getLists='getLists'></cancel-flow>
          </span>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <project-info></project-info>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import CancelFlow from '@/components/CancelFlow'
  import UserInfo from '@/components/UserInfo'
  import ApprovalStatus from '@/components/ApprovalStatus'
  import projectInfo from '@/page/user/projectInfo'
  import Role from '@/Mixins/role'
  export default {
    components: {
      UserInfo,
      projectInfo,
      ApprovalStatus,
      CancelFlow,
    },
    mixins: [Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        organizationListData: [],
        noSelectOrganization: true,
        depId: '',

        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],

        // 筛选搜索
        filterKey: "",
        filterType: 0,

        // 款项支付所属类型
        payTypeList: [],
        listType: 0,

        // 取消审批相关
        cancleStatus: false,
        form: {
          flowId: '',
          remark: '',
        },
      }
    },
    created() {},
    mounted() {
      this.getLists()
    },
    methods: {

      // 编辑的链接生成
      getRouterLink(applyId, projectId) {
        this.$router.push({
          path: '/Purchase/Apply',
          query: {
            applyId: applyId,
          }
        })
      },

      // 取消审批提交
      cancelFlowSubmit() {
        ajax.post('/gc/project/flow/cancel', this.form, (res) => {
          this.$message.success("取消审批成功")
          this.$store.commit('set_projectReload', true)
          this.cancleStatus = false
          this.getLists()
        })
      },
      // 取消审批弹窗
      cancelFlow(flow) {
        this.form.flowId = flow.id
        this.cancleStatus = true
      },

      // 显示审批详情
      projectDetail(row) {
        console.log(row)
        let _projectTable = {
          status: true,
          applyId: row.flow.applyId,
          tableType: row.flow.flowsource,
        }
        this.$store.commit('set_projectTable', _projectTable)
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选数据
      getFilterData() {
        if (this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _item = this.listData[i]

            // 筛选搜索结果
            if ((_item.number && _item.number.toLowerCase().indexOf(this.filterKey.toLowerCase()) !=
                -1) || (_item.name && _item.name.toLowerCase().indexOf(this.filterKey
                  .toLowerCase()) !=
                -1) || _item
              .flow
              .creator.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1) {
              this.filterData.push(_item)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        this.loading = true
        let _url = '/user/purchase/apply/list'
        if (this.listType == 1) {
          _url = '/user/purchase/record/list'
        }

        ajax.get(_url, '', (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getFilterData()
        })

        // ajax.get('/purchase/apply/list', {
        //   'depId': this.depId == 0 ? "" : this.depId,
        //   'type': this.listType > 1 ? 1 : this.listType
        // }, (res) => {
        //   this.loading = false
        //   let _resArr = []

        //   switch (this.listType) {
        //     case '1':
        //       _resArr = res.vo.array.filter((item) => {
        //         return item.flow.status == '审批通过'
        //       })
        //       break;
        //     case '2':
        //       _resArr = res.vo.array.filter((item) => {
        //         return item.flow.status != '审批通过'
        //       })
        //       break;
        //     default:
        //       _resArr = res.vo.array
        //       break;
        //   }

        //   this.filterData = this.listData = _resArr
        //   this.getFilterData()
        // })
      },
    },
    watch: {
      // 'depId'() {
      //   this.currentPage = 1
      //   this.getLists()
      // },
      'filterKey'() {
        this.getFilterData()
      },

      listType() {
        this.currentPage = 1
        this.getLists()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/user/purchaselist.vue